/* global moment*/
angular
  .module('statVehicleMake')
  .component('statVehicleMake', {
    template: require('./stat-vehicle-make.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function StatVehicleMakerController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'stat';
        $rootScope.menu = 'vehicleMake';
        $scope.selectedCityId = '-1';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        const promiseVehicleMakeCount = page => $resource(`${APIURL}/admin/stat/vehicle/make/counts`).get({ page }).$promise.then((data) => {
          this.count = data.count;
          this.brands = data.brands;
        });

        this.reload = (page) => {
          const promises = [promiseVehicleMakeCount(page - 1)];
          Promise.all(promises).then(() => {});
        };

        this.reload(1);
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/stat-vehicle-make/stat-vehicle-make.component.js